import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

export const downloadTemplateAction = async (entityPrimaryIds = []) => {
  try {
    const response = await apiClient.post(
      ATP_API_URL.DOWNLOAD_TEMPLATE,
      { entityPrimaryIds },
      { responseType: "blob" },
    );

    if (response?.status === 200 && response.data) {
      const disposition = response.headers?.["content-disposition"] || "";
      const match = disposition.match(/filename[^;=\n]*=([^;\n]*)/);
      const rawName = match?.[1]?.trim().replace(/['"]/g, "") || "";
      const fileName = rawName || `LedgerTemplate_${Date.now()}.xlsx`;

      const url = URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      return { success: true };
    }

    return { success: false, message: "Failed to download template" };
  } catch (error) {
    console.error("[DownloadTemplate] error:", error);
    return {
      success: false,
      message: error.message || "Failed to download template",
    };
  }
};
